/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */

export const formatCurrency = (value: number, currency = 'USD', decimals = 2): string => {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency,
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  }).format(value);
};

export const formatNumber = (value: number, decimals = 2): string => {
  return new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 0,
    maximumFractionDigits: decimals,
  }).format(value);
};

export const formatPercentage = (value: number, decimals = 2): string => {
    return `${value > 0 ? '+' : ''}${value.toFixed(decimals)}%`;
};

export const formatAddress = (address: string, chars = 4): string => {
  if (!address) return '';
  return `${address.slice(0, chars)}...${address.slice(-chars)}`;
};

export const formatCompact = (number: number): string => {
  return new Intl.NumberFormat('en-US', {
    notation: "compact",
    maximumFractionDigits: 1
  }).format(number);
};

export const toBaseUnit = (amount: number, decimals: number): string => {
  return Math.floor(amount * Math.pow(10, decimals)).toString();
};

export const fromBaseUnit = (amount: string | number, decimals: number): number => {
  return Number(amount) / Math.pow(10, decimals);
};

export const isValidSolanaAddress = (address: string): boolean => {
  return /^[1-9A-HJ-NP-Za-km-z]{32,44}$/.test(address);
};

export const isValidSuiAddress = (address: string): boolean => {
  return /^(0x)?[0-9a-fA-F]{64}$/.test(address);
};